module.exports = __webpack_public_path__ + "static/media/notfound-desktop.1c56685b.jpg";